var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('h1',[_vm._v(_vm._s(_vm.$tc(_vm.$translate.NewWidgetOfCompany)))]),_c('router-link',{attrs:{"to":{
        name: 'apiKeysMain'
      }}},[_c('i',{staticClass:"fa fa-chevron-left",attrs:{"title":_vm.$tc(_vm.$translate.Back)}})])],1),_c('hr'),_c('widget-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }